// useAuth isn't in Nuxt's auto-generated globals (it's from @apptegy/nuxt-auth, not Nuxt
// core), so eslint's no-undef needs it explicit — see the same import in useAuthServiceApi.ts.
import { useAuth } from '#imports';
import { adminRedirectFor } from '~/utils/adminRedirect';

export default defineNuxtRouteMiddleware((to, _from) => {
  // The district-picker route is an auth-flow route handled by `@apptegy/nuxt-auth`'s own
  // middleware; redirecting a logged-in admin away from it here would loop against that
  // middleware sending apex-domain visitors back to `/district-picker`.
  if (to.name === 'district-picker') return;

  const { userProfile } = useAuth();
  // Synchronous middleware, so Nuxt context is intact (same requirement as useAuth).
  const { $ld } = useNuxtApp();
  const redirect = adminRedirectFor(to.path, userProfile.value, $ld?.flags);
  if (redirect) return navigateTo(redirect);
});
